export const ITEMS_GET_REQUEST = "@items.get.request";
export const ITEMS_GET_SUCCESS = "@items.get.success";
export const ITEMS_GET_FAIL = "@items.get.failure";
export const ITEMS_GET_DONE = "@items.get.done";

export const ITEM_LOAD_REQUEST = "@item.load.request";
export const ITEM_LOAD_SUCCESS = "@item.load.success";
export const ITEM_LOAD_FAIL = "@item.load.failure";

export const ITEM_CREATE_REQUEST = "@item.create.request";
export const ITEM_CREATE_SUCCESS = "@item.create.success";
export const ITEM_CREATE_FAIL = "@item.create.failure";
export const ITEM_CREATE_DONE = "@item.create.done";

export const ITEM_UPDATE_REQUEST = "@item.update.request";
export const ITEM_UPDATE_SUCCESS = "@item.update.success";
export const ITEM_UPDATE_FAIL = "@item.update.failure";
export const ITEM_UPDATE_DONE = "@item.update.done";
